import TickIcon from 'assets/icons/tick.svg';

export interface StepperProps {
  title: string;
  steps: string[];
  step: number;
}

function Stepper(props: StepperProps) {
  const stepsLength = (props.steps.length - 1);

  const getListItemClassName = (index: number) => {
    if (index < props.step) {
      return '_past';
    }
    if (index === props.step && index < stepsLength) {
      return '_current';
    }
    if (index === props.step && index === stepsLength) {
      return '_current _tick';
    }
    return '_tick';
  };

  return (
    <div className="ct_stepper">
      <div className="ct_stepper-title ct_body3 _bold">
        {props.title}
      </div>
      <ul className="ct_stepper-pagination">
        {(props.steps || []).map((s, index) => (
          <li
            key={s}
            className={`ct_stepper-paginationItem ${getListItemClassName(index)}`}
          >
            <span className="ct_stepper-paginationDot">
              {props.step >= stepsLength ? <TickIcon /> : null}
            </span>
            <div className="ct_stepper-paginationText">
              {s}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Stepper;
